import { OfferContextEvent } from 'analytics/snowplow/context'
import React from 'react'

export interface OfferPageStateTracking {
  trackEvent: (event: OfferContextEvent) => void
}

function defaultTrackEvent(event: string) {
  console.warn(`Tracking for ${event} is not implemented`)
}

const OfferPageStateTrackingContext = React.createContext<OfferPageStateTracking>({ trackEvent: defaultTrackEvent })

export default OfferPageStateTrackingContext
